<template>
  <div
    class="squircle-md bg-surface-raised flex min-w-56 flex-col gap-2 rounded border"
  >
    <div class="flex flex-row items-center gap-3">
      <div
        class="squircle-l-md flex aspect-square h-14 min-w-0 items-center justify-center overflow-hidden rounded-l"
      >
        <img
          v-if="isImg"
          :src="objectUrl"
          class="inset-0 block aspect-square h-full w-full object-cover"
        />
        <FontAwesomeIcon v-else :icon="['fal', 'file']" size="xl" />
      </div>
      <div class="flex min-w-0 flex-1 flex-col py-3">
        <h4 class="truncate leading-none font-bold">{{ attachment.name }}</h4>
        <p class="text-xxs text-shadow-slate-500">
          {{ Math.round(attachment.size / 1024) }} Kb
        </p>
      </div>
      <div class="flex h-full items-center justify-center pr-3">
        <BaseDropDownMenu
          :options="[
            {
              label: $t('button.delete'),
              icon: 'trash',
              gate: true,
              bg_color: 'bg-red-500',
              txt_color: 'text-white',
              action: () => $emit('remove-attachment')
            }
          ]"
          size="small"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseDropDownMenu from '@c/addf-package/components/dropdown/BaseDropDownMenu.vue'

export default {
  name: 'LocalFileAttachmentComponent',
  components: { BaseDropDownMenu, FontAwesomeIcon },
  props: {
    attachment: {
      type: Object,
      required: true
    }
  },
  emits: ['remove-attachment'],
  data() {
    return {
      objectUrl: null
    }
  },
  computed: {
    isImg() {
      return (
        this.attachment.type === 'image/jpeg' ||
        this.attachment.type === 'image/png'
      )
    }
  },
  mounted() {
    this.objectUrl = URL.createObjectURL(this.attachment)
  },
  beforeUnmount() {
    URL.revokeObjectURL(this.objectUrl)
  }
}
</script>
